import * as React from 'react';

import {ConfirmationDialog} from 'shells/confirmation-dialog/confirmation-dialog';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

type Props = {
    onClose: () => void;
};

export function AdBlockerDialog(props: Props) {
    return (
        <ConfirmationDialog
            title='Ad blocker detected'
            message={
                <Stack spacing={8}>
                    <Body size='large'>
                        Some features in Nutshell may be inaccessible while using an ad blocker.
                        Please disable your ad blocker to leave feedback.
                    </Body>
                    <Body size='large'>
                        You can also email your feedback to{' '}
                        <Link variant='primary' href='mailto:beta@nutshell.com'>
                            beta@nutshell.com
                        </Link>
                    </Body>
                </Stack>
            }
            cancelText='Close'
            onCancel={props.onClose}
            isConfirmDestructive={false}
        />
    );
}
